import React, { useState,useEffect } from 'react';
import { Button, Form, Input, Select, App, Radio, Checkbox, InputNumber } from 'antd';
import styles from './StoreEntryStep5.module.scss';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { IFormDataAll } from '../../types';
import { saveApplyMerchant } from '@/api/store';
import { setUserInfo } from '@/store/slices/userSlice';
import CookieUtil from '@/utils/cookies';
import { useTranslation } from 'react-i18next';
export interface StoreEntryStep5Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  onCancel?: () => void;
  storeType?: 'individual' | 'business';
  formData?: IFormDataAll;
}

const { Option } = Select;

// 店铺入驻第五步：Payouts & Risk Control
const StoreEntryStep5: React.FC<StoreEntryStep5Props> = ({
  onNext,
  onPrev,
  onCancel,
  storeType = 'business', // 默认为企业类型
  formData
}) => {
  const { message } = App.useApp();
  //美国州列表
  const StateList = useAppSelector((state) => state.common.StateList);
  const userInfo = useAppSelector((state) => state.user.userInfo);
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const [form] = Form.useForm();

  // 处理提交
  const handleSubmit = () => {
    form.validateFields().then(values => {
      console.log('Form values:', values);

      const submitData = {
        ...formData,
        ...values,
      }

      console.log('StoreEntryStep5 - formData:', formData);
      console.log('StoreEntryStep5 - submitData:', submitData);
      console.log('StoreEntryStep5 - primary_category:', submitData.primary_category, typeof submitData.primary_category);

      saveApplyMerchant(submitData).then(res => {
        console.log('res2222222:', res);
        if(res.code === 200){
          //debugger;
          // 更新用户信息
          const returnedMerchantId = res?.data?.merchant_id ?? res?.merchant_id ?? res?.data?.id;
          if (returnedMerchantId !== undefined) {
            const mergedUserInfo = { ...(userInfo || {}), merchant_id: returnedMerchantId } as any;
            CookieUtil.set('userInfo', mergedUserInfo, { expires: 7 });
            dispatch(setUserInfo(mergedUserInfo));
          }
          onNext && onNext(values);
        }else{
          message.error(res.message);
        }
      });

      
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };

   // 初始化表单数据 编辑回传
   useEffect(() => {
    // 如果有formData，则填充表单
    if (formData) {
      // 只设置第3步相关的字段，避免设置不存在的字段
      const step5Fields = {
        payout_account_type: formData.payout_account_type,
        payment_method: formData.payment_method,
        account_number: formData.account_number,
        routing_number: formData.routing_number,
        account_name: formData.account_name,
        bank_name: formData.bank_name,
        payout_schedule: formData.payout_schedule,
        reserve_amount: formData.reserve_amount,
        reserve_period: formData.reserve_period,
        kyc_kyb_status: formData.kyc_kyb_status,
        form_1099k_consent: formData.form_1099k_consent,
        form_1099k_delivery_method: formData.form_1099k_delivery_method,
      };
      
      form.setFieldsValue(step5Fields);
    }
  }, [formData]);

  // 渲染表单内容（个人和企业使用相同的表单）
  const renderForm = () => {
    return (
      <>
        {/* Payout Account Section */}
        <div className={styles['section-title']}>{t('StoreEntryStep5.PayoutAccount')}</div>
        
        <div className={styles['form-row']}>
          <Form.Item
            name="payout_account_type"
            label={<span className={styles['required-label']}>*{t('StoreEntryStep5.PayoutAccount')} Type</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseSelectPayoutAccountType') }]}
            className={styles['form-item-half']}
          >
            <Select 
              placeholder={t('StoreEntryStep5.PleaseSelectPayoutAccountType')}
              onChange={(value) => {
                // 当支付账户类型改变时，清空支付方式的选择
                form.setFieldsValue({ payment_method: undefined });
              }}
              
            >
              <Option value="bank_account">{t('StoreEntryStep5.BankAccount')}</Option>
              <Option value="payment_processor">{t('StoreEntryStep5.PaymentProcessor')}</Option>
            </Select>
          </Form.Item>

          <Form.Item shouldUpdate>
            {({ getFieldValue }) => (
              <Form.Item
                name="payment_method"
                label={<span className={styles['required-label']}>{t('StoreEntryStep5.PaymentMethod')}</span>}
                rules={[{ required: true, message: t('StoreEntryStep5.PleaseSelectPaymentMethod') }]}
                className={styles['form-item-half']}
              >
                <Select placeholder={t('StoreEntryStep5.PleaseSelectPaymentMethod')}>
                  {getFieldValue('payout_account_type') === 'bank_account' ? (
                    <>
                      <Option value="checking">{t('StoreEntryStep5.Checking')}</Option>
                      <Option value="savings">{t('StoreEntryStep5.Savings')}</Option>
                    </>
                  ) : (
                    <>
                      <Option value="paypal">{t('StoreEntryStep5.PayPal')}</Option>
                      <Option value="stripe">{t('StoreEntryStep5.Stripe')}</Option>
                      <Option value="payoneer">{t('StoreEntryStep5.Payoneer')}</Option>
                      <Option value="square">{t('StoreEntryStep5.Square')}</Option>
                    </>
                  )}
                </Select>
              </Form.Item>
            )}
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="account_number"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.AccountNumber')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseEnterAccountNumber') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep5.AccountNumber')} />
          </Form.Item>

          <Form.Item
            name="routing_number"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.RoutingBA')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseEnterRoutingNumber') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep5.RoutingBA')} />
          </Form.Item>
        </div>

        <div className={styles['form-row']}>
          <Form.Item
            name="account_name"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.AccountName')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseEnterAccountName') }]}
            className={styles['form-item-half']}
          >
            <Input placeholder={t('StoreEntryStep5.AccountName')} />
          </Form.Item>

          <Form.Item
            name="bank_name"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.BankName')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseEnterBankName') }]}
            className={styles['form-item-half']}
          >
            <Select placeholder={t('StoreEntryStep5.PleaseEnterBankName')}>
              <Option value="chase">{t('StoreEntryStep5.Chase')}</Option>
              <Option value="bank_of_america">{t('StoreEntryStep5.BankAmerica')}</Option>
              <Option value="wells_fargo">{t('StoreEntryStep5.WellsFargo')}</Option>
              <Option value="citibank">{t('StoreEntryStep5.Citibank')}</Option>
              <Option value="other">{t('StoreEntryStep5.Other')}</Option>
            </Select>
          </Form.Item>
        </div>

        {/* Payout Schedule Section */}
        <div className={styles['form-row']}>
          <Form.Item
            name="payout_schedule"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.PayoutSchedule')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseSelectPayoutSchedule') }]}
            className={styles['form-item-full']}
          >
            <Select placeholder={t('StoreEntryStep5.Daily')}>
              <Option value="daily">{t('StoreEntryStep5.Daily')}</Option>
              <Option value="weekly">{t('StoreEntryStep5.Weekly')}</Option>
              <Option value="bi_weekly">{t('StoreEntryStep5.Biweekly')}</Option>
              <Option value="monthly">{t('StoreEntryStep5.Monthly')}</Option>
            </Select>
          </Form.Item>
        </div>

        {/* Reserve Settings Section */}
        <div className={styles['form-row']}>
          <Form.Item
            name="reserve_amount"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.ReserveUSD')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseEnterReserveAmount') }]}
            className={styles['form-item-half']}
          >
            <InputNumber 
              placeholder="500" 
              style={{ width: '100%' }}
              min={0}
              addonBefore="$"
            />
          </Form.Item>

          <Form.Item
            name="reserve_period"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.ReserveDays')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseEnterReservePeriod') }]}
            className={styles['form-item-half']}
          >
            <InputNumber 
              placeholder="7" 
              style={{ width: '100%' }}
              min={1}
              max={365}
            />
          </Form.Item>
        </div>

        {/* KYC/KYB Status Section */}
        <div className={styles['form-row']}>
          <Form.Item
            name="kyc_kyb_status"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.KYCStatus')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseSelectKYCStatus') }]}
            className={styles['form-item-full']}
          >
            <Select placeholder="Approved">
              <Option value="pending">Pending</Option>
              <Option value="approved">Approved</Option>
              <Option value="rejected">Rejected</Option>
            </Select>
          </Form.Item>
        </div>

        {/* 1099-K Consent Section */}
        <div className={styles['form-row']}>
          <Form.Item
            name="form_1099k_consent"
            valuePropName="checked"
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseConsentTo1099K') }]}
            className={styles['form-item-full']}
          >
            <Checkbox>{t('StoreEntryStep5.IK')}</Checkbox>
          </Form.Item>

          <div style={{color: '#2AADAD',marginBottom:"10px"}}>{t('StoreEntryStep5.Theform')}</div>

        </div>

        {/* Tax Form Delivery Method Section */}
        <div className={styles['form-row']}>
          <Form.Item
            name="form_1099k_delivery_method"
            label={<span className={styles['required-label']}>{t('StoreEntryStep5.TaxMethod')}</span>}
            rules={[{ required: true, message: t('StoreEntryStep5.PleaseSelectDeliveryMethod') }]}
            className={styles['form-item-full']}
          >
            <Radio.Group>
              <Radio value="email">{t('StoreEntryStep5.Email')}</Radio>
              <Radio value="postal_mail">{t('StoreEntryStep5.PostalMail')}</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
      </>
    );
  };

  return (
    <div className={styles['store-entry-step5']}>
      <div className={styles['header']}>
        <div className={styles['header-title']}>{t('StoreEntryStep5.PayoutsControl')}</div>
        <div className={styles['header-protection']}>
          <span className={styles['protection-icon']}>✓</span>
          {t('StoreEntryStep5.YourOut')}
        </div>
      </div>

      <Form form={form} layout="vertical" initialValues={{
    form_1099k_consent: true, // 默认勾选
    form_1099k_delivery_method: "email", // 默认 Email
  }}>
        {renderForm()}

        {/* 按钮区域 */}
        <div className={styles['button-container']}>
          <Button
            className={styles['back-button']}
            onClick={onPrev}
          >
            {t('StoreEntryStep5.Back')}
          </Button>
          <Button
            type="primary"
            className={styles['next-button']}
            onClick={handleSubmit}
          >
            {t('StoreEntryStep5.Next')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default StoreEntryStep5; 